export const APP_VERSION = "50.0.23";
